import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import clearKnock from '@shoflo/studio-redux/actions/knock/clearKnock';
import {
  BROADCAST_ACCEPT_KNOCK,
  BROADCAST_UPDATE_KNOCK
} from '@shoflo/studio-redux/actions/knock/types';
import {
  isValidKnock,
  sendMeetingToAttendee,
  getGenericKnockPayload
} from './utils';

/**
 * Emits an event to the accepted Presenter socket (Agora path only)
 *
 * @param {*} socket
 */
export function acceptedKnockMiddleware(socket) {
  return store => next => async action => {
    const targetdActions = [
      `${BROADCAST_ACCEPT_KNOCK}`,
      `${BROADCAST_UPDATE_KNOCK}_SUCCESS`
    ];
    from([action])
      .pipe(filter($action => targetdActions.includes($action.type)))
      .subscribe(async $action => {
        if (!isValidKnock($action)) return;

        const { dispatch, getState } = store;

        const {
          attendeeRoster,
          program,
          team,
          broadcastSettings,
          banners,
          streamEndpoints
        } = getState();

        const payload = getGenericKnockPayload({
          getState,
          action: $action,
          banners,
          streamEndpoints,
          attendeeRoster,
          program,
          broadcastSettings,
          team
        });

        sendMeetingToAttendee(socket, payload);
        dispatch(clearKnock($action.payload));
      });
    return next(action);
  };
}

export default acceptedKnockMiddleware;
